import React from 'react'
import './Skills.scss'
import {ReactComponent as HexagonStraight} from '../../assets/hexagon-straight.svg'
import Section from '../../components/Section/Section'
const Skills = () => {
    return (<>
        <div className="skills__background">
            <div className="skills__background-hexagonstraight skills__background-element hexagon"><HexagonStraight/></div>
        </div>
        <div className='skills'>
            <div className="skills__section"><Section text="Skills">Skills</Section></div>

            <div className="skill">
                <div className="skills__content">
                    <div className="skills__name heading-5">REACT & NEXT</div>
                </div>
                <div className="skills__content">
                    <div className="skills__name heading-5">SOLIDITY</div>
                </div>
                <div className="skills__content">
                    <div className="skills__name heading-5">VUE & NUXT</div>
                </div>
                <div className="skills__content">
                    <div className="skills__name heading-5">NODE</div>
                </div>
                <div className="skills__content">
                    <div className="skills__name heading-5">SOLID.JS</div>
                </div>
                <div className="skills__content">
                    <div className="skills__name heading-5">PYTHON</div>
                </div>
                <div className="skills__content">
                    <div className="skills__name heading-5">TAILWIND CSS</div>
                </div>
                <div className="skills__content">
                    <div className="skills__name heading-5">C#</div>
                </div>
                <div className="skills__content">
                    <div className="skills__name heading-5">VUETIFY</div>
                </div>
                <div className="skills__content">
                    <div className="skills__name heading-5">TYPESCRIPT</div>
                </div>
                <div className="skills__content">
                    <div className="skills__name heading-5">WEB3</div>
                </div>
                <div className="skills__content">
                    <div className="skills__name heading-5">JAVASCRIPT</div>
                </div>
            </div>
            
        </div>
        </>
    )
}

export default Skills
